import { Component, OnInit, Input } from '@angular/core';
import {
  WardDirectoryParameters,
  CampusWard,
  AcademicSession
} from '../../shared';
import { MemberInfo } from '../../shared/models/ecclesiastical/member-info.model'

@Component({
  selector: 'app-ward-directory-list',
  templateUrl: './ward-directory-list.component.html',
  styleUrls: ['./ward-directory-list.component.scss'],
  // encapsulation: ViewEncapsulation.None // for kendo-pdf-export styling
})
export class WardDirectoryListComponent implements OnInit {

  @Input() directoryParameters: WardDirectoryParameters;
  @Input() selectedAcademicSession: AcademicSession;
  @Input() ward: CampusWard;
  @Input() student: MemberInfo;

  returnedMissionary = false;
  constructor() { }

  ngOnInit() {
  }
  validPhoneNumber() {
    if (this.student.cellPhone != null && this.student.cellPhone.length > 0) {
      return true;
    }
    return false;
  }

  /**
   * Returns true if there's a home church unit number
   */
  validHomeUnitNumber() {
    return (this.student.homeChurchUnit);
  }
}
